import "./style.scss";
import $ from 'jquery';

$(document).ready(function () {

    $(".query-all-services-block-wrap").each(function () {
        let loadmoreCheck = $(this).attr('data-load-more');
        let loadMoreUUID = $(this).attr('data-uuid');

        if (loadmoreCheck == 1) {

            let displayLimit = 3;
            let filterCount = parseInt($('.query-all-services-block-wrap[data-uuid=' + loadMoreUUID + ']').attr('data-count'));
            let displayCounter = 0;


            render_staff_members(displayLimit, displayCounter, loadMoreUUID);
            $('.query-block__load-more[data-uuid=' + loadMoreUUID + '] a').on("click", function () {
                render_staff_members(displayLimit, displayCounter, loadMoreUUID);
            });

            function render_staff_members(displayLimit, displayCounter, loadMoreUUID) {
                displayLimit = $('.query-block__load-more[data-uuid=' + loadMoreUUID + ']').attr('data-display-limit');
                $('.query-block__load-more[data-uuid=' + loadMoreUUID + ']').attr('data-display-limit', parseInt(displayLimit) + 3);

                if (filterCount < parseInt(displayLimit)) {
                    $('.query-block__load-more[data-uuid=' + loadMoreUUID + ']').hide();
                } else {
                    $('.query-block__load-more[data-uuid=' + loadMoreUUID + ']').show();
                }

                $('.query-all-services-block-wrap[data-uuid=' + loadMoreUUID + '] .card-element').hide();
                $('.query-all-services-block-wrap[data-uuid=' + loadMoreUUID + '] .card-element').each(function () {
                    if (displayCounter < displayLimit) {
                        $(this).show();
                        displayCounter++;
                    }
                });
            }
        }
    });
});